import styled from '@emotion/styled';
import { PRIMARY } from '../../../../shared/colors';

const MAX_VISIBLE_NEWS = 5;

const NEWS_ITEMS = [
  {
    time: '23:14',
    source: 'BZFR',
    symbol: 'BTA',
    title: '12 titres de consommation discrétionnaire en mouvement',
    tone: 'important',
  },
  {
    time: '23:14',
    source: 'USIG',
    symbol: 'OTA',
    title: 'Volume spike up sur le segment régional',
  },
  {
    time: '23:14',
    source: 'LTHM',
    symbol: 'TECH',
    title: "Titres informatique en mouvement lors de la session d'apprentissage",
  },
  {
    time: '23:14',
    source: 'BZFR',
    symbol: 'BTA',
    title: 'Consommation discrétionnaire en mouvement',
  },
  {
    time: '23:14',
    source: 'BZFR',
    symbol: 'COM',
    title: 'Titres de service de communication en mouvement',
  },
  {
    time: '23:14',
    source: 'BZFR',
    symbol: 'REG',
    title: 'Marché régional stable en clôture',
  },
];

const Container = styled.div`
  height: 100%;

  > .top {
    background:
      linear-gradient(135deg, rgba(255, 79, 31, 0.16), transparent 42%),
      ${PRIMARY};
    padding: 8px 12px;
    font-family: Poppins-B;
    text-transform: uppercase;
    color: var(--mt-warning);
  }

  > .content {
    height: calc(100% - 38px);
    box-sizing: border-box;
    padding: 10px 12px 12px;
    overflow-x: hidden;
    overflow-y: auto;
    font-family: Poppins-R;
    font-size: 11px;
    line-height: 1.45;

    .news-summary {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      margin-bottom: 6px;
      color: var(--mt-muted);
      font-size: 11px;
    }

    .news-summary strong {
      color: var(--mt-text);
      font-family: Poppins-B;
    }

    .news-summary span {
      padding: 3px 8px;
      border: 1px solid rgba(255, 176, 0, 0.35);
      border-radius: 999px;
      color: var(--mt-warning);
      font-family: Poppins-B;
    }

    .news-list {
      display: grid;
      gap: 5px;
    }

    .news-item {
      display: grid;
      grid-template-columns: 48px 56px 58px minmax(0, 1fr);
      align-items: center;
      gap: 8px;
      min-height: 26px;
      padding: 3px 7px;
      border: 1px solid var(--mt-border);
      border-radius: 7px;
      background-color: var(--mt-card);
      cursor: pointer;
      transition:
        border-color 0.15s ease,
        background-color 0.15s ease;

      &:hover {
        border-color: rgba(255, 176, 0, 0.42);
        background-color: var(--mt-surface);
      }
    }

    .news-time,
    .news-source {
      color: var(--mt-muted);
      font-size: 10px;
      white-space: nowrap;
    }

    .news-symbol {
      justify-self: start;
      padding: 2px 6px;
      border-radius: 999px;
      color: var(--mt-warning);
      background-color: rgba(255, 176, 0, 0.12);
      border: 1px solid rgba(255, 176, 0, 0.24);
      font-family: Poppins-B;
      font-size: 10px;
    }

    .news-title {
      min-width: 0;
      overflow: hidden;
      color: var(--mt-text);
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .news-item.important {
      box-shadow: inset 3px 0 0 var(--mt-accent);
    }

    &::-webkit-scrollbar {
      width: 0.5vw;
    }

    &::-webkit-scrollbar-thumb {
      background-image: linear-gradient(to bottom, #eceff1, #eceff1);
      border-radius: 10px;
    }
  }
`;

export const News = () => {
  const visibleNews = NEWS_ITEMS.slice(0, MAX_VISIBLE_NEWS);
  const hiddenNews = Math.max(NEWS_ITEMS.length - visibleNews.length, 0);

  return (
    <Container>
      <div className='top'>Actualités</div>
      <div className='content'>
        <div className='news-summary'>
          <strong>Flux marché</strong>
          <span>
            {visibleNews.length}/{NEWS_ITEMS.length} affichées
          </span>
        </div>

        <div className='news-list'>
          {visibleNews.map((item, index) => (
            <div
              className={`news-item ${item.tone === 'important' ? 'important' : ''}`}
              key={`${item.source}-${item.symbol}-${index}`}
            >
              <span className='news-time'>{item.time}</span>
              <span className='news-source'>{item.source}</span>
              <span className='news-symbol'>{item.symbol}</span>
              <span className='news-title'>{item.title}</span>
            </div>
          ))}
        </div>

        {hiddenNews > 0 && (
          <div className='news-summary' style={{ marginTop: 8, marginBottom: 0 }}>
            <span>{hiddenNews} actualité masquée</span>
            <strong>Vue complète dans Fiches et Infos</strong>
          </div>
        )}
      </div>
    </Container>
  );
};
